function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  clipPath: "url(#clip0_3746_152855)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 11.48v2.85c0 .83.5 1.46 1.27 1.63.14.03.29.04.44.04h4.05c1.03 0 1.7-.68 1.7-1.7V8.6a1.6 1.6 0 00-1.69-1.66H1.7c-1.03 0-1.7.67-1.7 1.7v2.84zm1.07 0V8.65c0-.46.2-.65.65-.65h4.04c.44 0 .64.2.64.64v5.66c0 .43-.2.63-.63.63H1.7c-.45 0-.64-.2-.64-.64v-2.8z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12.9 4.24a.62.62 0 000-1.24H8.61a.62.62 0 100 1.24h4.27zm.51-.62c0 .29-.23.52-.52.52H8.62a.52.52 0 110-1.04h4.27c.29 0 .52.23.52.52zM12.9 7.24a.62.62 0 000-1.24H8.62a.62.62 0 000 1.24h4.28zm.51-.62c0 .29-.23.52-.51.52H8.62a.52.52 0 010-1.04h4.28c.28 0 .51.23.51.52z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M15.72 1.44c0-.8-.64-1.44-1.44-1.44H4.44C3.64 0 3 .64 3 1.44v3.38a.62.62 0 101.23 0V1.44c0-.12.1-.2.2-.2h9.85c.12 0 .2.08.2.2v13.12c0 .12-.08.2-.2.2h-4.6a.62.62 0 100 1.24h4.6c.8 0 1.44-.64 1.44-1.44V1.44z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9 4.14a.52.52 0 000-1.04H8.61a.52.52 0 100 1.04h4.27zM12.9 7.14c.28 0 .51-.23.51-.52a.52.52 0 00-.51-.52H8.62a.52.52 0 100 1.04h4.28z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.67 9.62c0-.34.28-.62.63-.62h2.49a.62.62 0 010 1.24h-2.5a.62.62 0 01-.62-.62zm3.55-.29c.06.08.09.18.09.3 0 .28-.23.51-.52.51h-2.5 2.5a.52.52 0 00.43-.8zM12.16 12.62a.62.62 0 011.25 0 .62.62 0 01-1.25 0zm1 .36a.52.52 0 00-.37-.88.52.52 0 01.37.88z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.14 9.6c0 .29.24.52.53.52H4.8c.29 0 .52-.23.52-.52a.52.52 0 00-.52-.53H2.67a.52.52 0 00-.53.53zM5.32 11.73a.52.52 0 00-.52-.52.52.52 0 000 1.04c.29 0 .52-.24.52-.52zM2.67 12.25c.29 0 .52-.23.52-.52a.52.52 0 00-1.05 0c0 .29.24.52.53.52zM4.8 12.81a.52.52 0 100 1.04.52.52 0 000-1.04zM2.14 13.33c0 .3.24.53.53.53.29 0 .52-.24.52-.53a.52.52 0 00-1.05 0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3746_152855"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z",
  transform: "matrix(-1 0 0 1 16 0)"
})));

function SvgAccounting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounting);
export default __webpack_public_path__ + "static/media/accounting.8e679817.svg";
export { ForwardRef as ReactComponent };